/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AaiOperationTrait } from '../../asyncapi/models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../../asyncapi/models/AaiOperationTraitDefinition';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { Node } from '../../core/models/Node';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';

/**
 * A command used to rename a operation trait definition item in an AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @param {string} oldName
 * @param {string} newName
 * @class
 * @extends AbstractCommand
 */
export class RenameOperationTraitDefinitionCommand extends AbstractCommand {
    public _oldName : string;

    public _newName : string;

    public _references : Array<NodePath>;

    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            (() => {
                this._oldName = oldName;
                this._newName = newName;
            })();
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameOperationTraitDefinitionCommand] Executing.");
        this._references = <any>([]);
        let doc : AaiDocument = <AaiDocument>document;
        if(this.renameOperationTraitDefinition(doc, this._oldName, this._newName)) {
            let oldRef : string = this.nameToReference(this._oldName);
            let newRef : string = this.nameToReference(this._newName);
            let finder : RenameOperationTraitDefinitionCommand.OperationTraitRefFinder = new RenameOperationTraitDefinitionCommand.OperationTraitRefFinder(oldRef);
            let traits : Array<AaiOperationTrait> = finder.findIn(document);
            for(let index153=0; index153 < traits.length; index153++) {
                let trait = traits[index153];
                {
                    /* add */(this._references.push(Library.createNodePath(trait))>0);
                    trait.$ref = newRef;
                }
            }
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameOperationTraitDefinitionCommand] Reverting.");
        if(this.renameOperationTraitDefinition(<AaiDocument>document, this._newName, this._oldName)) {
            let oldRef : string = this.nameToReference(this._oldName);
            if(ModelUtils.isDefined(this._references)) {
                this._references.forEach(((oldRef) => {
                    return (ref) => {
                        let trait : AaiOperationTrait = <AaiOperationTrait>ref.resolve(document);
                        trait.$ref = oldRef;
                    }
                })(oldRef));
            }
        }
    }

    nameToReference(name : string) : string {
        return "#/components/operationTraits/" + name;
    }

    renameOperationTraitDefinition(document : AaiDocument, fromName : string, toName : string) : boolean {
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(doc20.components) || this.isNullOrUndefined(doc20.components.operationTraits)) {
            return false;
        }
        if(ModelUtils.isDefined(doc20.components.getOperationTraitDefinition(toName))) {
            return false;
        }
        let traitDef : AaiOperationTraitDefinition = doc20.components.removeOperationTraitDefinition(fromName);
        traitDef.rename(toName);
        doc20.components.addOperationTraitDefinition(toName, traitDef);
        return true;
    }
}
RenameOperationTraitDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameOperationTraitDefinitionCommand";
RenameOperationTraitDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameOperationTraitDefinitionCommand {

    export class OperationTraitRefFinder extends CombinedVisitorAdapter {
        reference : string;

        traits : Array<AaiOperationTrait> = <any>([]);

        public constructor(ref : string) {
            super();
            if(this.reference===undefined) this.reference = null;
            this.reference = ref;
        }

        public findIn(document : Document) : Array<AaiOperationTrait> {
            VisitorUtil.visitTree(document, this, TraverserDirection.down);
            return this.traits;
        }

        /**
         * 
         * @param {AaiOperationTrait} node
         */
        public visitOperationTrait(node : AaiOperationTrait) {
            if(this.accept(node)) {
                /* add */(this.traits.push(node)>0);
            }
        }

        accept(trait : AaiOperationTrait) : boolean {
            return ModelUtils.isDefined(trait.$ref) && NodeCompat.equals(trait.$ref, this.reference);
        }
    }
    OperationTraitRefFinder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameOperationTraitDefinitionCommand.OperationTraitRefFinder";
    OperationTraitRefFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}



